export default function HeroSection() {
  const chips = [
    { icon: "ri-fire-fill", label: "今日新增", value: "6 条" },
    { icon: "ri-eye-line", label: "追踪中", value: "35 条" },
    { icon: "ri-question-mark", label: "待核实", value: "19 条" },
    { icon: "ri-check-double-line", label: "已澄清", value: "74 条" },
    { icon: "ri-chat-quote-line", label: "当事人已回应", value: "68%" },
  ];

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20abstract%20editorial%20background%2C%20deep%20charcoal%20with%20faint%20crimson%20and%20amber%20light%20streaks%2C%20subtle%20grain%20texture%2C%20cinematic%20investigation%20report%20atmosphere%2C%20minimal%2C%20muted%20tones%2C%20high%20contrast%2C%20no%20people&width=1600&height=860&seq=hero-bg-douyin-2026&orientation=landscape"
          alt="快手黑料事件追踪背景"
          className="h-full w-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/70 to-background-50" />
      </div>

      <div className="relative mx-auto w-full max-w-[1400px] px-4 pb-10 pt-28 md:px-6 md:pt-36">
        <div className="mx-auto max-w-4xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-500/10 px-3 py-1 text-xs text-accent-300">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            持续跟进中 · 辟谣 反转 当事人回应 公关动态
          </span>

          <h1 className="mt-6 font-heading text-3xl leading-tight font-black text-foreground-950 md:text-6xl md:leading-[1.08]">
            黑料不只看一面，
            <span className="text-accent-400">反转要看全过程</span>
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            快手黑料事件的最新回应与反转动态，我们逐条汇总当事人声明、辟谣内容与后续进展，同时复盘背后的公关操作与澄清节奏。给你一份可对照、可回溯的事件时间线，避免被单方面说法带偏。
          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#tracking"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:w-auto"
            >
              进入事件追踪
              <i className="ri-arrow-right-line text-base" />
            </a>
            <a
              href="#factcheck"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-100/60 px-6 py-3 text-sm font-medium text-foreground-900 transition hover:bg-background-200/60 sm:w-auto"
            >
              查看辟谣核查清单
              <i className="ri-checkbox-multiple-line text-base text-accent-400" />
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-2 sm:grid-cols-5 sm:gap-3">
            {chips.map((c) => (
              <div
                key={c.label}
                className="rounded-lg border border-background-200/70 bg-background-100/50 px-3 py-3 text-left"
              >
                <div className="flex items-center gap-1.5 text-foreground-600">
                  <i className={`${c.icon} text-sm ${c.label === "已澄清" ? "text-secondary-400" : "text-accent-400"}`} />
                  <span className="text-[11px]">{c.label}</span>
                </div>
                <div className="mt-1 font-heading text-lg font-bold text-foreground-950 md:text-xl">{c.value}</div>
              </div>
            ))}
          </div>

          <p className="mt-4 text-[11px] text-foreground-600">
            内容为公开信息整理的状态示意，仅供参考，不构成事实认定。
          </p>
        </div>
      </div>
    </section>
  );
}